export const CARD_WIDTH = 164;
export const CARD_GAP = 8;
export const GRID_PAD = 24;
export const MIN_LIBRARY_WIDTH = 360;
export const MAX_LIBRARY_WIDTH = GRID_PAD + CARD_WIDTH * 5 + CARD_GAP * 4;

export function columnsForWidth(width: number): number {
  const inner = width - GRID_PAD;
  return Math.max(2, Math.min(5, Math.floor((inner + CARD_GAP) / (CARD_WIDTH + CARD_GAP))));
}

export function widthForColumns(count: number): number {
  const columns = Math.max(2, Math.min(5, count));
  return GRID_PAD + CARD_WIDTH * columns + CARD_GAP * (columns - 1);
}
